import React from 'react';

import Switch, { SwitchProps } from '@material-ui/core/Switch';
import cx from 'classnames';

import styles from './switchBtn.module.scss';

interface ExtendedSwitchProps extends SwitchProps {
  classes?: {
    label?: string;
    root?: string;
    thumb?: string;
    track?: string;
    switchBase?: string;
    checked?: string;
  };
}

const SwitchButton = ({
  buttonText,
  className,
  classes,
  ...props
}: { buttonText: React.ReactNode } & ExtendedSwitchProps) => {
  return (
    (<div
      className={cx(styles.unreadToggler, className)}
      data-testid="unread-bellAlert-toggler"
      data-palette="SwitchButton">
      <span className={cx(styles.unreadText, classes?.label)}>{buttonText}</span>
      <Switch
        classes={{
          root: cx(styles.switchRoot, classes?.root),
          thumb: cx(styles.switchThumb, classes?.thumb),
          track: cx(styles.switchTrack, classes?.track),
          switchBase: cx(styles.switchBase, classes?.switchBase),
          checked: cx(styles.switchChecked, classes?.checked),
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </div>)
  );
};

export default SwitchButton;
